import React, { useEffect, useState, useContext, useRef } from "react";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import ReactPlayer from "react-player";
import { ThemeAudioContext } from "../../components/ThemeAudioContext";
import axios from "axios";

const ExitVideo = () => {
  const navigate = useNavigate();
  const [exitVideoUrl, setExitVideo] = useState("");
  const [exitAudioUrl, setExitAudio] = useState("");
  const [playVideo, setPlayVideo] = useState(false);
  const exitAudioRef = React.useRef(null);
  const bgNarration = useRef(null);

  const {
    reduceThemeAudioVolume,
    restoreThemeAudioVolume,
  } = useContext(ThemeAudioContext);

  const navigateToLanding = () => navigate("/");

   useEffect(() => {
      // 🔥 kill background audio
      if (window.__BG_AUDIO__) {
        try {
          window.__BG_AUDIO__.pause();
          window.__BG_AUDIO__.currentTime = 0;
        } catch (e) { }
        window.__BG_AUDIO__ = null;
      }
  
      // 🔥 kill narration audio
      if (window.__NARRATION_AUDIO__) {
        try {
          window.__NARRATION_AUDIO__.pause();
          window.__NARRATION_AUDIO__.currentTime = 0;
        } catch (e) { }
        window.__NARRATION_AUDIO__ = null;
      }
  
      // 🔥 also kill any DOM audio just in case
      document.querySelectorAll("audio").forEach((a) => {
        try {
          a.pause();
          a.currentTime = 0;
        } catch (e) { }
      });
    }, []);

  useEffect(() => {
    getColors();
    getVideos();
    getAudios();
  }, []);

  useEffect(() => {
    // Play audio once URL is loaded
    if (exitAudioUrl) {
      startBackgroundNarrationAudio();
      playExitAudio();
    }

    // Stop audio on unmount
    return () => {
      stopExitAudio();
    };
  }, [exitAudioUrl]);

  // Stop audio on back/forward navigation
  useEffect(() => {
    const handlePopState = () => {
      stopExitAudio();
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const videoReady = () => {
    setPlayVideo(true);
  };

  const getColors = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_API + "Colors/getColors");
      document.documentElement.style.setProperty("--primary-color", response.data.primaryColor);
      document.documentElement.style.setProperty("--secondary-color", response.data.secondaryColor);
    } catch (error) {
      console.error(error);
    }
  };

  const getVideos = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_API + "Videos/getVideos");
      setExitVideo(response.data.exitVideo);
    } catch (error) {
      console.error(error);
    }
  };

  const getAudios = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_API + "Audios/getAudios");
      switch (localStorage.getItem("language")) {
        case "en":
          setExitAudio(response.data.exitAudio);
          break;
        case "sl":
          setExitAudio(response.data.exitAudioSinhala);
          break;
        case "tm":
          setExitAudio(response.data.exitAudioTamil);
          break;
        default:
          break;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const playExitAudio = () => {
    if (!exitAudioUrl) return;

    // Stop previous audio if any
    stopExitAudio();

    const audio = new Audio(exitAudioUrl);
    audio.loop = false;
    audio.muted = false;
    audio.volume = 1;
    exitAudioRef.current = audio;

    // When audio finishes
    audio.onended = () => {
      bgNarration.current.volume = 0.5;
      exitAudioRef.current = null;
    };

    // Try autoplay (handle browser restrictions)
    const tryPlay = () => {
      bgNarration.current.volume = 0.1;
      audio.play().catch(() => {
        // If blocked, do nothing; will retry on user click
      });
    };

    tryPlay();

    const handleUserClick = () => {
      if (exitAudioRef.current) {
        tryPlay();
      }
      window.removeEventListener("click", handleUserClick);
    };
    window.addEventListener("click", handleUserClick);
  };

  const stopExitAudio = () => {
    if (exitAudioRef.current) {
      exitAudioRef.current.pause();
      exitAudioRef.current.currentTime = 0;
      exitAudioRef.current = null;
      bgNarration.current.volume = 0.5;
    }
  };

  const startBackgroundNarrationAudio = () => {
    if (bgNarration.current) return;
    const bgNarrationAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777371784/11_Outro_Musiconly_Master_m8fxt9.mp3");
    window.__BG_AUDIO__ = bgNarrationAudio;
    bgNarrationAudio.loop = true; // keep it soft
    bgNarrationAudio.volume = 0.5; // keep it soft
    bgNarration.current = bgNarrationAudio;
    bgNarrationAudio.play().catch(() => { });
  };

  const stopAllAudio = () => {
    stopIntroAudio();

    if (bgNarration.current) {
      bgNarration.current.pause();
      bgNarration.current.currentTime = 0;
      bgNarration.current = null;
    }
  };

  return (
    <div className="video-page-container mob-center-align">
      {!playVideo && <div className="loading-black-bg"></div>}
      <div className="video-bg">
        <ReactPlayer
          url={exitVideoUrl}
          className="video-container-video"
          loop={false}
          playing={playVideo}
          muted={true}
          controls={false}
          playsinline={true}
          onReady={() => videoReady()}
          onEnded={() => {
            stopExitAudio(); // Stop audio before navigating
            navigateToLanding();
          }}
        />
        <div id="startTourBtnContainer" className="start-btn-container hide-exit-btn-container">
          <Button
            className="start-tour-btn"
            variant="contained"
            onClick={() => {
              stopExitAudio();
              navigateToLanding();
            }}
          >
            START TOUR AGAIN
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ExitVideo;
